import { render } from "./FormColor.vue?vue&type=template&id=27a1d18d&scoped=true&ts=true"
import script from "./FormColor.vue?vue&type=script&lang=ts"
export * from "./FormColor.vue?vue&type=script&lang=ts"

import "./FormColor.vue?vue&type=style&index=0&id=27a1d18d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a1d18d"]])

export default __exports__